import { h } from 'preact';

import { isProdDomain } from '../../../../utils/aem-utils';
import SkyItMessengerPeople from '../../../components/4-organisms/sky-it-messenger-people/sky-it-messenger-people';

export const renderMessengerPeople = ({ data, telegramWidgetId, messengerWidgetId }) => (
  <SkyItMessengerPeople
    boxTitle={data.title}
    boxDescription={data.description}
    telegramWidgetId={isProdDomain() ? telegramWidgetId?.prodEnvironement : telegramWidgetId?.collEnvironement}
    facebookWidgetId={isProdDomain() ? messengerWidgetId?.prodEnvironement : messengerWidgetId?.collEnvironement}
  />
);
